import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'
import { addOnlyToPeopleByKennitala } from '../customers/actions'

export const nationalRegistryTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS', 'REQUEST_STR', 'RECEIVE_STR', 'ERROR_STR', 'SUCCESS_STR', 'REQUEST_NAMESPACED', 'RECEIVE_NAMESPACED', 'REQUEST_NAMESPACED_STRING', 'RECEIVE_NAMESPACED_STRING', 'ERROR_NAMESPACED', 'SUCCESS_NAMESPACED'], 'REGISTRY');


export const requestNationalRegistry = () => {
    return {
        type: nationalRegistryTypes.REQUEST,
    };
};

export const receiveNationalRegistry = (response, query={}, onlyLookup) => {
    return {
        type: nationalRegistryTypes.RECEIVE,
        query: query,
        data: response,
        onlyLookup: onlyLookup,
    };
};

export const receiveNationalRegistryStr = (response, query={}, onlyLookup) => {
    return {
        type: nationalRegistryTypes.RECEIVE_STR,
        query: query,
        data: response,
        onlyLookup: onlyLookup,
    };
};


export const receiveNationalRegistryError = () => {
    return {
        type: nationalRegistryTypes.ERROR,
    };
};

export const fetchNationalRegistry = (customerId, onlyLookup) => {
    return dispatch => {
        const apiUrl = `/api/v1/lookup/${customerId}/`

        dispatch(requestNationalRegistry());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
            .then(parseJSON)
            .then(response => {
                try {
                    dispatch(receiveNationalRegistry(response, customerId, onlyLookup));
                    dispatch(addOnlyToPeopleByKennitala(response));
                } catch (e) {
                    dispatch(receiveNationalRegistryError(response))
                }
            })
            .catch(handleNetworkError);
    };
};

export const fetchNationalRegistryString = (string, onlyLookup) => {
    return dispatch => {
        const apiUrl = `/api/v1/lookupstring/${string}/`

        dispatch(requestNationalRegistry());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
            .then(parseJSON)
            .then(response => {
                try {
                    dispatch(receiveNationalRegistryStr(response, string, onlyLookup));
                } catch (e) {
                    dispatch(receiveNationalRegistryError(response))
                }
            })
            .catch(handleNetworkError);
    };
};



export const requestNationalRegistryNamespaced = (namespace) => {
    return {
        type: nationalRegistryTypes.REQUEST_NAMESPACED,
        namespace: namespace,
    };
};

export const receiveNationalRegistryNamespaced = (response, query={}, onlyLookup, namespace) => {
    return {
        type: nationalRegistryTypes.RECEIVE_NAMESPACED,
        query: query,
        data: response,
        onlyLookup: onlyLookup,
        namespace: namespace
    };
};

export const requestNationalRegistryNamespacedString = (namespace) => {
    return {
        type: nationalRegistryTypes.REQUEST_NAMESPACED_STRING,
        namespace: namespace,
    };
};

export const receiveNationalRegistryNamespacedString = (response, query={}, onlyLookup, namespace) => {
    return {
        type: nationalRegistryTypes.RECEIVE_NAMESPACED_STRING,
        query: query,
        data: response,
        onlyLookup: onlyLookup,
        namespace: namespace
    };
};

export const receiveNationalRegistryNamespacedError = () => {
    return {
        type: nationalRegistryTypes.ERROR_NAMESPACED,
    };
};

export const fetchNationalRegistryNamespaced = (customerId, onlyLookup, namespace) => {
    return dispatch => {
        const apiUrl = `/api/v1/lookup/${customerId}/`

        dispatch(requestNationalRegistryNamespaced(namespace));

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
            .then(parseJSON)
            .then(response => {
                try {
                    dispatch(receiveNationalRegistryNamespaced(response, customerId, onlyLookup, namespace));
                    dispatch(addOnlyToPeopleByKennitala(response));
                } catch (e) {
                    dispatch(receiveNationalRegistryNamespacedError(response))
                }
            })
            .catch(handleNetworkError);
    };
};

export const fetchNationalRegistryNamespacedString = (string, onlyLookup, namespace) => {
    return dispatch => {
        const apiUrl = `/api/v1/lookupstring/${string}/`

        dispatch(requestNationalRegistryNamespacedString(namespace));

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
            .then(parseJSON)
            .then(response => {
                try {
                    dispatch(receiveNationalRegistryNamespacedString(response, string, onlyLookup, namespace));
                } catch (e) {
                    console.log("Error: ", e)
                    dispatch(receiveNationalRegistryNamespacedError(response))
                }
            })
            .catch(handleNetworkError);
    };
}; 
